import React from 'react';
import { Button, Icon } from 'antd';
import cn from 'classnames';
import styles from './AddEntityBtn.module.scss';

const AddEntityBtn = ({ text, className, ...props }) => {
  return (
    <Button
      {...props}
      ghost
      className={cn(styles.root, className)}
    >
      <Icon
        type="plus-circle"
        className={styles.icon}
      />
      {text || 'Добавить'}
    </Button>
  );
};

export default AddEntityBtn;
